import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISharedReport } from "api/reports/reports.type";

// The reports shared with the user's team (`GET /v1/reports`, REF-7271). App-wide because the main menu — on every
// page — shows "Reports" only when this list is non-empty. Loaded once per signed-in user by `hooks/useSharedReports`.
interface ReportsState {
  items: ISharedReport[];
  /** The user the list was requested for. A Layout remount for the same user does not fetch again. */
  loadedFor: string | null;
  status: "idle" | "loading" | "ready" | "error";
  /** Bumped by every request; a response writes only while it is still the latest one. */
  requestId: number;
}

const initialState: ReportsState = {
  items: [],
  loadedFor: null,
  status: "idle",
  requestId: 0,
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    sharedReportsRequested: (state, action: PayloadAction<string>) => {
      state.loadedFor = action.payload;
      state.status = "loading";
      state.requestId += 1;
    },
    sharedReportsReceived: (state, action: PayloadAction<ISharedReport[]>) => {
      state.items = action.payload;
      state.status = "ready";
    },
    // The menu hides the item rather than guess; the page offers a retry.
    sharedReportsFailed: (state) => {
      state.items = [];
      state.status = "error";
    },
  },
});

export const { sharedReportsRequested, sharedReportsReceived, sharedReportsFailed } = reportsSlice.actions;
